
const TrustBanner = () => {
  const features = [
    { icon: 'ri-shield-check-line', text: 'Insured Vehicles' },
    { icon: 'ri-time-line', text: 'Same-Day Service' },
    { icon: 'ri-price-tag-3-line', text: 'No Hidden Fees' },
    { icon: 'ri-map-pin-line', text: 'Serving All KZN' },
  ];

  return (
    <div className="relative -mt-16 z-20">
      <div className="container mx-auto px-6">
        <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-xl py-8 px-6">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
            {features.map((feature, index) => (
              <div key={index} className="flex items-center justify-center space-x-3">
                <i className={`${feature.icon} text-primary text-3xl w-8 h-8 flex items-center justify-center`}></i>
                <span className="font-semibold text-charcoal">{feature.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustBanner;
